import React from "react";
import LeafletMap from "./LeafletMap"; 

function MapAnalysis() {
  return (
    <div id="map" className="w-full   lg:mt-[12rem] mt-[10rem]"> 
      <LeafletMap />
    </div>
  );
}

export default MapAnalysis;
